import script from "./EditDevice.vue?vue&type=script&setup=true&lang=js"
export * from "./EditDevice.vue?vue&type=script&setup=true&lang=js"

import "./EditDevice.vue?vue&type=style&index=0&id=54342efa&scope=true&lang=css"

const __exports__ = script;

export default __exports__